var m = require('mithril');
var modalForm = require('../layout/components/modalForm');
var elementForm = modalForm(require('../dashboards/models/element'));
var datasetForm = modalForm(require('../data/models/dataset'));
var edit = require('../layout/components/edit');
var helpModal = require('../help/helpModal');

module.exports = {
  view: function (vnode) {
    var ctrl = this;
    var options = vnode.attrs;
    ctrl.parentReinitialize = options.parentReinitialize;
    ctrl.dashboardCallback = vnode.attrs.dashboardCallback
    if (Array.isArray(options)) {
      content = options;
      options = {};
    } 
    if(edit.vm.editing() && options.element){
      return m('div.f1.bb.bw1.flex.justify-between.items-center.narrow.grid-item-drag-handle', {style:{cursor: 'grab'}}, [
        m('span.blue', {
          onclick: vnode.attrs.datasetRepresentation ?
            datasetForm.editDialogue.bind(datasetForm, {...options.element, '@class': 'Dataset'}, {delete:options.element.name == 'Default' ? false : true, submitCallback: ctrl.parentReinitialize, dashboardCallback: ctrl.dashboardCallback})
          :
            elementForm.editDialogue.bind(elementForm, options.element , {delete: options.element.name == 'Default' ? false : true, move:'true', submitCallback: ctrl.parentReinitialize, dashboardCallback: ctrl.dashboardCallback})
        },[
          options.datasetRepresentation && options.element.name == 'Default' ?
            `${options.element.name} (${options.element.parentName})`
          :
            options.element.name ? 
              options.element.name
            : 
              m('i.ion-edit.blue') 
          ]),
      ])
    }else{
      return m('div.v-btm.bb.b--mid-gray.bw1.flex.justify-between', {class: options.class}, [
        m('div.flex.items-center.overflow-hidden', [
          options.element && 
          options.datasetRepresentation && 
          options.element.out_Contains &&
          Array.isArray(options.element.out_Contains) &&
          options.element.out_Contains[0] &&
          options.element.out_Contains[0].in &&
          options.element.out_Contains[0].in.url ?
            m('a', {href: options.element.out_Contains[0].in.url}, options.element.name)                            
          :
            m('div', {
              class: options.labelClass,
              onclick: vnode.attrs.onClikLabel ? vnode.attrs.onClikLabel : ''
            }, options.label),
          options.helpIcon ? 
            m('i.ion-ios-help-outline.white.f2.ml2', {
              onclick: () => {
                helpModal.editDialogue(options.helpModalTitle, options.helpFileName)
              }
            })
          :
            ''
        ]), 
        m('div', vnode.children)  
      ]); 
    }

    
  }
};


